const collapseFiltersBlocks = (filtersContainer) => {
  const collapseElements = filtersContainer.querySelectorAll(`.js-collapse`);

  const TOP_STICKY_COORDINATE = 136;

  if (collapseElements.length) {
    if (window.matchMedia(`(min-width: 1200px)`).matches) {
      const collapseAll = () => {
        collapseElements.forEach((element) => {
          if (element.dataset.checked !== `true`) {
            element.classList.remove(`open`);
          }
        });
      };

      const esxpandAll = () => {
        collapseElements.forEach((element) => element.classList.add(`open`));
      };

      const setScrollStatus = (isScroll) => {
        switch (isScroll) {
          case true:
            filtersContainer.classList.add(`filters--scroll`);
            break;
          case false:
            filtersContainer.classList.remove(`filters--scroll`);
            break;
        }
      };

      const setCollapseStatus = () => {
        if (filtersContainer.getBoundingClientRect().top <= TOP_STICKY_COORDINATE) {
          collapseAll();
          setScrollStatus(true);
        } else {
          esxpandAll();
          setScrollStatus(false);
        }
      };

      const onMouseLeaveFilterBlock = (evt) => {
        if (filtersContainer.getBoundingClientRect().top <= TOP_STICKY_COORDINATE) {
          if (evt.currentTarget.dataset.checked !== `true`) {
            evt.currentTarget.classList.remove(`open`);
          }
        }
      };

      const onMouseEnterFilterBlock = (evt) => {
        if (filtersContainer.getBoundingClientRect().top <= TOP_STICKY_COORDINATE) {
          evt.currentTarget.classList.add(`open`);
        }
      };

      const onClickFilterBlock = (evt) => {
        if (
          evt.target.classList.contains(`js-collapse-btn`) ||
          evt.target.closest(`.js-collapse-btn`)
        ) {
          evt.currentTarget.classList.toggle(`open`);
        }
      };

      const addEvent = () => {
        collapseElements.forEach((element) => {
          element.addEventListener(`click`, onClickFilterBlock);
          element.addEventListener(`mouseenter`, onMouseEnterFilterBlock);
          // element.addEventListener(`mouseleave`, onMouseLeaveFilterBlock);
        });
        filtersContainer.addEventListener(`mouseleave`, collapseAll);
      };

      addEvent();

      setCollapseStatus();

      window.addEventListener(`scroll`, setCollapseStatus);
    }
  }
};

export default collapseFiltersBlocks;
